/**
 * ============================================================
 * English
 * ============================================================
 *
 * Translators:
 *
 * Hyuchia <diego@hyuchia.com>
 */



export default {
	'AdvanceHelp': 'To advance through the game, left-click or tap anywhere on the game screen or press the space key',
	'AllowPlayback': 'Click here to allow audio playback',
	'Audio': 'Audio',
	'AutoPlay': 'Auto',
	'AutoPlayButton': 'Enable auto play',
	'AutoPlaySpeed': 'Autoplay Speed',

	'Back': 'Back',
	'BackButton': 'Go back',

	'Cancel': 'Cancel',
	'Close': 'Close',
	'Confirm': 'Do you want to quit?',
	'Credits': 'Credits',

	'Delete': 'Delete',
	'DialogLogButton': 'Show the dialog log',

	'FullScreen': 'Full Screen',

	'Gallery': 'Gallery',

	'Help': 'Help',
	'Hide': 'Hide',
	'HideButton': 'Hide the text box',

	'iOSAudioWarning': 'Audio settings are not supported on iOS',

	'KeyboardShortcuts': 'Keyboard Shortcuts',

	'Language': 'Language',
	'Load': 'Load',
	'LoadAutoSaveSlots': 'Auto Saved Games',
	'LoadButton': 'Open the Load Screen',
	'Loading': 'Loading',
	'LoadingMessage': 'Wait while the assets are loaded',
	'LoadSlots': 'Saved Games',
	'LocalStorageWarning': 'Local Storage is not available in this browser',
	'Log': 'Log',

	'Music': 'Music Volume',

	'NewContent': 'There is new content available, reload the page to get the latest version',
	'NoSavedGames': 'No saved games',
	'NoAutoSavedGames': 'No automatically saved games',
	'NoDialogsAvailable': 'No dialogs available. Dialogs will appear here as they show up',

	'OK': 'OK',
	'OrientationWarning': 'Please rotate your device to play',
	'Overwrite': 'Overwrite',

	'QuickButtons': 'Quick Menu Buttons',
	'QuickMenu': 'Quick Menu',
	'Quit': 'Quit',
	'QuitButton': 'Quit Game',

	'Resolution': 'Resolution',

	'Save': 'Save',
	'SaveButton': 'Open the Save Screen',
	'SaveInSlot': 'Save in slot',
	'SelectYourLanguage': 'Select your language',
	'Settings': 'Settings',
	'SettingsButton': 'Open the Settings Screen',
	'Show': 'Show',
	'Skip': 'Skip',
	'SkipButton': 'Enter skip mode',
	'SlotDeletion': 'Are you sure you want to delete this slot?',
	'SlotOverwrite': 'Are you sure you want to overwrite this slot?',
	'Sound': 'Sound Volume',
	'Start': 'Start',
	'Stop': 'Stop',

	'TextSpeed': 'Text Speed',

	'Video': 'Video Volume',
	'Voice': 'Voice Volume',

	'Windowed': 'Windowed'
};